<template>
  <div style="margin: 20px 0 20px 0; padding:20px 20px 20px 20px; background-color: white">
    <el-form :inline="true">
      <el-form-item label="日期">
        <el-date-picker
            v-model="dateRange"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="对冲产品:">
        <el-select v-model="hedgeProductType" placeholder="请选择对冲产品">
          <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="对冲目标类型:">
        <el-select v-model="hedgeTargetType" placeholder="请选择对冲目标类型">
          <el-option v-for="item in hedgeTargetTypeEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="对冲目标值:">
        <el-input v-model="hedgeTargetValue" placeholder="请选择对冲目标类值"></el-input>
      </el-form-item>
      <el-form-item label="交易对:">
        <el-input v-model="pair" placeholder="请输入交易对"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryHedgeCycleBenefitStatistics">查询</el-button>
      </el-form-item>
    </el-form>

    <div v-if="isShow">
      <el-table :data="tableData" style="width: 100%" max-height="1000">
        <el-table-column fixed prop="strategy" label="策略" sortable width="150"></el-table-column>
        <el-table-column label="交易平台" align="center">
          <el-table-column prop="exchangeBidQuantity" label="成交数量（买）" sortable width="80"></el-table-column>
          <el-table-column prop="exchangeAskQuantity" label="成交数量（卖）" sortable width="80"></el-table-column>
          <el-table-column prop="exchangeBidAvgPrice" label="成交均价（买）" sortable width="80"></el-table-column>
          <el-table-column prop="exchangeAskAvgPrice" label="成交均价（卖）" sortable width="80"></el-table-column>
          <el-table-column prop="exchangeFixedBenefit" label="固定盈亏" sortable width="80"></el-table-column>
          <el-table-column prop="exchangeFloatBenefit" label="浮动盈亏" sortable width="80"></el-table-column>
        </el-table-column>
        <el-table-column label="程序成功对冲" align="center">
          <el-table-column prop="autoHedgeBidQuantity" label="成交数量（买）" sortable width="80"></el-table-column>
          <el-table-column prop="autoHedgeAskQuantity" label="成交数量（卖）" sortable width="80"></el-table-column>
          <el-table-column prop="autoHedgeBidAvgPrice" label="成交均价（买）" sortable width="80"></el-table-column>
          <el-table-column prop="autoHedgeAskAvgPrice" label="成交均价（卖）" sortable width="80"></el-table-column>
          <el-table-column prop="autoHedgeFixedBenefit" label="买卖盈亏" sortable width="80"></el-table-column>
        </el-table-column>
        <el-table-column  label="人工成功对冲" align="center">
          <el-table-column prop="manualHedgeBidQuantity" label="成交数量（买）" sortable width="80"></el-table-column>
          <el-table-column prop="manualHedgeAskQuantity" label="成交数量（卖）" sortable width="80"></el-table-column>
          <el-table-column prop="manualHedgeBidAvgPrice" label="成交均价（买）" sortable width="80"></el-table-column>
          <el-table-column prop="manualHedgeAskAvgPrice" label="成交均价（卖）" sortable width="80"></el-table-column>
          <el-table-column prop="manualHedgeFixedBenefit" label="买卖盈亏" sortable width="80"></el-table-column>
        </el-table-column>
        <el-table-column label="需对冲量" align="center">
          <el-table-column prop="quantityNotHedged" label="需对冲数量" sortable width="80"></el-table-column>
          <el-table-column prop="suggestedHedgePrice" label="建议对冲价" sortable width="80"></el-table-column>
          <el-table-column prop="notHedgeUsdtAmt" label="需对冲代币价值(USDT)" sortable width="80"></el-table-column>
        </el-table-column>
        <el-table-column label="盈利详情" align="center">
          <el-table-column prop="floatBenefitNotHedged" label="需要对冲浮动盈亏" sortable width="80"></el-table-column>
          <el-table-column prop="fixedBenefitTotal" label="总固定盈亏" sortable width="80"></el-table-column>
        </el-table-column>
        <el-table-column prop="currentPrice" label="现价" sortable width="80"></el-table-column>
        <el-table-column prop="startTime" label="周期开始时间" sortable width="80"></el-table-column>
        <el-table-column prop="endTime" label="周期结束时间" sortable width="80"></el-table-column>
        <el-table-column prop="" label="操作" width="110">
          <template slot-scope="scope">
            <el-button @click="deleteRecord(scope.row)" type="danger" size="small">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination background
                     layout="total, sizes, prev, pager, next, jumper"
                     :page-size="pageSize"
                     :page-sizes="[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                     :total="total"
                     :current-page="currentPageNum"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
      <div style="margin: 20px 0 20px 0; text-align: right">
        <el-button type="primary" :plain="true" @click="exportExcel">导出excel</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from './hedgeApi';
import '@/entries/Machine/cache'
import {mapState, mapActions} from "vuex";
import {RIGHTS_TYPE} from "@/common/constant";
import utils from "@/entries/HedgeCenter/MarketSheet/utils";

const hedgeTargetTypeSPOTOptions = [
  {key:'', label:''},
  {key:'SPOT_PAIR_COMMON', label:'现货匹配交易对'},
  {key:'SPOT_PAIR_API', label:'现货只匹配交易对的API的部分，优先级SPOT'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const hedgeTargetTypeSUPER_CONTRACTOptions = [
  {key:'', label:''},
  {key:'SC_PAIR', label:'超级合约的交易对'},
  {key:'SC_USER_ID', label:'超级合约的交易对用户ID'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const hedgeTargetTypeOptions = []
const columns=[
  {title:'策略',key:'strategy'},
  {title:'平台买方成交数量',key:'exchangeBidQuantity'},
  {title:'平台卖方成交数量',key:'exchangeAskQuantity'},
  {title:'平台买方成交均价',key:'exchangeBidAvgPrice'},
  {title:'平台卖方成交均价',key:'exchangeAskAvgPrice'},
  {title:'平台固定盈亏',key:'exchangeFixedBenefit'},
  {title:'平台浮动盈亏',key:'exchangeFloatBenefit'},
  {title:'程序成功对冲买方成交数量',key:'autoHedgeBidQuantity'},
  {title:'程序成功对冲卖方成交数量',key:'autoHedgeAskQuantity'},
  {title:'程序成功对冲买方成交均价',key:'autoHedgeBidAvgPrice'},
  {title:'程序成功对冲卖方成交均价',key:'autoHedgeAskAvgPrice'},
  {title:'程序成功对冲买卖盈亏',key:'autoHedgeFixedBenefit'},
  {title:'人工成功对冲买方成交数量',key:'manualHedgeBidQuantity'},
  {title:'人工成功对冲卖方成交数量',key:'manualHedgeAskQuantity'},
  {title:'人工成功对冲买方成交均价',key:'manualHedgeBidAvgPrice'},
  {title:'人工成功对冲卖方成交均价',key:'manualHedgeAskAvgPrice'},
  {title:'人工成功对冲买卖盈亏',key:'manualHedgeFixedBenefit'},
  {title:'需对冲数量',key:'quantityNotHedged'},
  {title:'需对冲价格',key:''},
  {title:'需对冲代币价值(USDT)',key:'notHedgeUsdtAmt'},
  {title:'需对冲浮动盈亏',key:'floatBenefitNotHedged'},
  {title:'总固定盈亏',key:'fixedBenefitTotal'},
  {title:'现价',key:'currentPrice'},
  {title:'周期开始时间',key:'startTime'},
  {title:'周期结束时间',key:'endTime'},
]

export default {
  name: "StrategyBenefit",
  data() {
    return {
      isShow: false,
      pages:0,
      pageSize: 20,
      total:0,
      currentPageNum:1,

      tableData:[],
      dateRange:'',
      buffer:'',

      pair:'',
      hedgeProductType:'',
      hedgeTargetType:'',
      hedgeTargetValue:'',
      hedgeTargetTypeEnum:'',
      hedgeTargetTypeEnum_SPOT:hedgeTargetTypeSPOTOptions,
      hedgeTargetTypeEnum_SUPER_CONTRACT:hedgeTargetTypeSUPER_CONTRACTOptions,
    }
  },
  computed: {
    params() {
      if ( this.dateRange ){
        return {
          startTime:new Date(this.dateRange[0]).getTime(),
          endTime:new Date(this.dateRange[1]).getTime(),
          hedgeProductType:this.hedgeProductType,
          hedgeTargetType:this.hedgeTargetType,
          hedgeTargetValue:this.hedgeTargetValue,
          pair:this.pair,
          pageSize: this.pageSize,
          pageNum: this.currentPageNum
        };
      } else {
        return {
          startTime:'',
          endTime:'',
          hedgeProductType:this.hedgeProductType,
          hedgeTargetType:this.hedgeTargetType,
          hedgeTargetValue:this.hedgeTargetValue,
          pair:this.pair,
          pageSize: this.pageSize,
          pageNum: this.currentPageNum
        };
      }

    },

    paramsBak() {
      return {
        dateRange:this.dateRange,
        hedgeProductType:this.hedgeProductType,
        hedgeTargetType:this.hedgeTargetType,
        hedgeTargetValue:this.hedgeTargetValue,
        pair:this.pair,
      };
    },
    ...mapState(["userInfo", "userRights"]),
    ...mapState('newHedgeStore', ['hedgeProductTypeOptions', 'pickerOptions']),
  },
  created() {
    this.hedgeProductType = this.hedgeProductTypeOptions[0].key;
    this.productType = this.hedgeProductTypeOptions[0].key;
    this.rightsContains()
  },
  watch:{
    hedgeProductType(val){
      if (val === "SPOT"){
        this.hedgeTargetTypeEnum = this.hedgeTargetTypeEnum_SPOT
      }else{
        this.hedgeTargetTypeEnum = this.hedgeTargetTypeEnum_SUPER_CONTRACT
      }
    },
  },
  methods: {
    rightsContains(r) {
      let rights = this.userRights.split(",") || [];
      return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
    },

    deleteRecord(data) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        utils.deleteHedgeCycleBenefitStatistics(data).then((response)=>{
          if (response.data === true){
            this.dialogVisible = false;
            this.$message.success('删除成功');
            this.queryHedgeCycleBenefitStatistics()
          }else{
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    handleSizeChange(val){
      this.params.pageSize = val
      this.queryHedgeCycleBenefitStatistics()
    },
    handleCurrentChange(val) {
      this.params.pageNum = val
      this.queryHedgeCycleBenefitStatistics()
    },

    queryHedgeCycleBenefitStatistics(){

      if (this.buffer === ''){
        this.buffer = this.paramsBak
      } else {
        if (this.buffer !== this.paramsBak){
          this.params.pageNum = 1
          this.buffer = this.paramsBak
        }
      }

      utils.queryHedgeCycleBenefitStatistics(this.params).then((response)=>{
        this.isShow = true
        this.total = response.data.total
        this.pages = response.data.pages
        this.pageSize = response.data.size
        this.currentPageNum = response.data.current
        let tableData = response.data.records
        for (let key in tableData){
          tableData[key].startTime = utils.getLocalTime(tableData[key].startTime)
          tableData[key].endTime = utils.getLocalTime(tableData[key].endTime)
        }
        this.tableData = tableData
      })
    },

    exportExcel(){
      let startTime = utils.getLocalTime(this.dateRange[0])
      let endTime = utils.getLocalTime(this.dateRange[1])
      let title = '对冲周期盈亏统计' + startTime + '-' + endTime
      utils.export2Excel(columns, this.tableData, title)
    }
  }
}
</script>

<style scoped>
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
</style>
